/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { accountMeChangePasswordUpdate } from '../fn/profile/account-me-change-password-update';
import { accountMeChangePasswordUpdate$FormData } from '../fn/profile/account-me-change-password-update-form-data';
import { AccountMeChangePasswordUpdate$FormData$Params } from '../fn/profile/account-me-change-password-update-form-data';
import { AccountMeChangePasswordUpdate$Params } from '../fn/profile/account-me-change-password-update';
import { accountMeChangePasswordUpdate$XWwwFormUrlencoded } from '../fn/profile/account-me-change-password-update-x-www-form-urlencoded';
import { AccountMeChangePasswordUpdate$XWwwFormUrlencoded$Params } from '../fn/profile/account-me-change-password-update-x-www-form-urlencoded';
import { accountMeHeaderInfoRetrieve } from '../fn/profile/account-me-header-info-retrieve';
import { AccountMeHeaderInfoRetrieve$Params } from '../fn/profile/account-me-header-info-retrieve';
import { BackendChangePasswordDto } from '../models/backend-change-password-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiProfileService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `accountMeChangePasswordUpdate()` */
  static readonly AccountMeChangePasswordUpdatePath = '/api/account/me/change_password/';

  /**
   * Представление для изменения пароля пользователя.
   * Принимает данные сериализатора с текущим и новым паролями.
   * Если данные валидны, обновляет пароль пользователя и возвращает новый токен авторизации.
   * Возвращает успешный статус код 200.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountMeChangePasswordUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountMeChangePasswordUpdate$Response(
    params: AccountMeChangePasswordUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendChangePasswordDto>> {
    return accountMeChangePasswordUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Представление для изменения пароля пользователя.
   * Принимает данные сериализатора с текущим и новым паролями.
   * Если данные валидны, обновляет пароль пользователя и возвращает новый токен авторизации.
   * Возвращает успешный статус код 200.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountMeChangePasswordUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountMeChangePasswordUpdate(
    params: AccountMeChangePasswordUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendChangePasswordDto> {
    return this.accountMeChangePasswordUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendChangePasswordDto>): BackendChangePasswordDto => r.body),
    );
  }

  /**
   * Представление для изменения пароля пользователя.
   * Принимает данные сериализатора с текущим и новым паролями.
   * Если данные валидны, обновляет пароль пользователя и возвращает новый токен авторизации.
   * Возвращает успешный статус код 200.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountMeChangePasswordUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  accountMeChangePasswordUpdate$XWwwFormUrlencoded$Response(
    params: AccountMeChangePasswordUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendChangePasswordDto>> {
    return accountMeChangePasswordUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Представление для изменения пароля пользователя.
   * Принимает данные сериализатора с текущим и новым паролями.
   * Если данные валидны, обновляет пароль пользователя и возвращает новый токен авторизации.
   * Возвращает успешный статус код 200.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountMeChangePasswordUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  accountMeChangePasswordUpdate$XWwwFormUrlencoded(
    params: AccountMeChangePasswordUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendChangePasswordDto> {
    return this.accountMeChangePasswordUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendChangePasswordDto>): BackendChangePasswordDto => r.body),
    );
  }

  /**
   * Представление для изменения пароля пользователя.
   * Принимает данные сериализатора с текущим и новым паролями.
   * Если данные валидны, обновляет пароль пользователя и возвращает новый токен авторизации.
   * Возвращает успешный статус код 200.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountMeChangePasswordUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  accountMeChangePasswordUpdate$FormData$Response(
    params: AccountMeChangePasswordUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendChangePasswordDto>> {
    return accountMeChangePasswordUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Представление для изменения пароля пользователя.
   * Принимает данные сериализатора с текущим и новым паролями.
   * Если данные валидны, обновляет пароль пользователя и возвращает новый токен авторизации.
   * Возвращает успешный статус код 200.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountMeChangePasswordUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  accountMeChangePasswordUpdate$FormData(
    params: AccountMeChangePasswordUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendChangePasswordDto> {
    return this.accountMeChangePasswordUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendChangePasswordDto>): BackendChangePasswordDto => r.body),
    );
  }

  /** Path part for operation `accountMeHeaderInfoRetrieve()` */
  static readonly AccountMeHeaderInfoRetrievePath = '/api/account/me/header_info/';

  /**
   * Представление для получения информации о пользователе для отображения в шапке фронта.
   * Возвращает данные о пользователе, включая имя, должность, информацию о тарифном плане,
   * информацию о верификации почты и возможность создания проектов.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountMeHeaderInfoRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  accountMeHeaderInfoRetrieve$Response(
    params?: AccountMeHeaderInfoRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return accountMeHeaderInfoRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Представление для получения информации о пользователе для отображения в шапке фронта.
   * Возвращает данные о пользователе, включая имя, должность, информацию о тарифном плане,
   * информацию о верификации почты и возможность создания проектов.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountMeHeaderInfoRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  accountMeHeaderInfoRetrieve(params?: AccountMeHeaderInfoRetrieve$Params, context?: HttpContext): Observable<void> {
    return this.accountMeHeaderInfoRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }
}
